module.exports = __webpack_public_path__ + "static/media/SDFSA_3-317w.1f64d222.webp";